import { FormComponent } from '@ubud/form';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { RegisterInstitution } from '@lemsar/auth/domains/models/register';
import { InstitutionType } from '@lemsar/common/domains/models/institution-type';
import { PostalCode } from '@lemsar/common/domains/models/addressing';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    12/06/2018
 */
@Component({
    selector: 'lemsar-register-institution-form',
    templateUrl: './register-institution.form.html',
})
export class RegisterInstitutionForm extends FormComponent<RegisterInstitution> implements OnInit, OnChanges {
    @ViewChild('combo') public combo: ComboBoxComponent;

    public government: string = 'government';
    public private: string = 'private';

    public industrial = 'industrial';
    public community = 'community';

    public companyCodeMask: string = '00000.00000.00000000.0-000';
    public value: string;
    public wlkpCodeShow: boolean;

    // public institutionTypeBtnGovernment: boolean = true;
    // public institutionTypeBtnPrivate: boolean = false;
    public dataPostalCodes: Array<PostalCode> = [];

    @Input() public registerType: string;
    @Input() public findCompany: boolean;
    @Input() public postalCodes: Array<PostalCode> = [];
    @Input() public institutionTypes: Array<InstitutionType> = [];
    @Input() public dataTypePrivateInstitution: { id: number; name: string }[];

    @Output() public change: EventEmitter<number> = new EventEmitter<number>();
    @Output() public changeCompanyCode: EventEmitter<string> = new EventEmitter<string>();
    @Output() public selectedRegisterType: EventEmitter<string> = new EventEmitter<string>();
    @Output() public changePrivateInstitutionType: EventEmitter<number> = new EventEmitter<number>();

    public ngOnInit(): void {
        // this.registerType = this.government;
    }

    public ngOnChanges(): void {
        this.dataPostalCodes = this.postalCodes;
    }

    public switchInstitutionType(type: string): void {
        // if (this.government === type) {
        //     this.institutionTypeBtnGovernment = true;
        //     this.institutionTypeBtnPrivate = false;
        // }

        // if (this.private === type) {
        //     this.institutionTypeBtnGovernment = false;
        //     this.institutionTypeBtnPrivate = true;
        // }

        this.registerType = type;
        this.selectedRegisterType.emit(this.registerType);
    }

    public handleFilter(value: any): void {
        this.change.emit(value);
    }

    public searchCompanyCode(): void {
        if (this.value) {
            this.changeCompanyCode.emit(this.value);
        }
    }

    public privateInstitutionTypeChange(value: any): void {
        if (10 === value.id) {
            this.wlkpCodeShow = false;
        } else {
            this.wlkpCodeShow = true;
        }

        this.changePrivateInstitutionType.emit(value.id);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/components/register-institution.form.ts